module.exports = __webpack_public_path__ + "img/5.421b69bb.png";